"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateFees = calculateFees;
const _1 = require(".");
function precision(value, precision) {
    return Math.round(value * Math.pow(10, precision)) / Math.pow(10, precision);
}
function calculate_fee_amount(salary, recruitmentFee, fee, currency) {
    for (let condition of fee.condition.rules) {
        let origin = fee.condition.origin === 'salary' ? salary : recruitmentFee;
        if (condition.min === condition.max || origin <= condition.max) {
            let feeCurrency = currency;
            let amount = 0;
            if (condition.fee.type === 'fixed') {
                // TODO currency conversion
                feeCurrency = condition.fee.amount.currency;
                amount = condition.fee.amount.value;
            }
            else if (salary === 0 || !salary) {
                let markup, margin;
                if (condition.fee.type === 'markup') {
                    markup = precision(condition.fee.amount.value, 2);
                    margin = precision(((markup / 100) / (1 + (markup / 100))) * 100, 2);
                }
                else if (condition.fee.type === 'margin') {
                    margin = precision(condition.fee.amount.value, 2);
                    markup = precision(((margin / 100) / (1 - (margin / 100))) * 100, 2);
                }
                return { currency: feeCurrency, amount: 0, markup, margin };
            }
            else {
                let base = condition.fee.origin === 'salary' ? salary : recruitmentFee;
                if (condition.fee.type === 'markup') {
                    amount = base * condition.fee.amount.value / 100;
                }
                else if (condition.fee.type === 'margin') {
                    amount = (condition.fee.amount.value / 100 * base) / (1 - condition.fee.amount.value / 100);
                }
            }
            return ({
                currency: feeCurrency,
                amount: amount,
                markup: precision(amount / salary * 100, 2),
                margin: precision(amount / (salary + amount) * 100, 2)
            });
        }
    }
    throw 'error';
}
function calculate_fee(salary, recruitmentFee, fee, currency) {
    if (typeof salary === 'object') {
        return ({
            payer: fee.payer,
            type: fee.type,
            range: {
                min: calculate_fee_amount(salary.min, typeof recruitmentFee === 'object' ? recruitmentFee.min : recruitmentFee, fee, currency),
                max: calculate_fee_amount(salary.max, typeof recruitmentFee === 'object' ? recruitmentFee.max : recruitmentFee, fee, currency)
            }
        });
    }
    return ({
        payer: fee.payer,
        type: fee.type,
        amount: calculate_fee_amount(salary, typeof recruitmentFee === 'object' ? recruitmentFee.min : recruitmentFee, fee, currency)
    });
}
//TODO employment interval
function calculateFees(salary, commercials, flag = 'employer') {
    commercials = JSON.parse(JSON.stringify(commercials));
    const normalizedSalary = (0, _1.calculateSalary)(salary, { value: 1, unit: 'year' }, commercials.currency);
    const recruitmentFeeSettings = commercials.fees.agency.find(fee => fee.type === 'recruitment');
    if (['agency', 'recruiter'].includes(flag) && commercials.agencyDeductionFee) {
        for (let rule of recruitmentFeeSettings.condition.rules) {
            if (rule.fee.type === 'markup' || rule.fee.type === 'margin') {
                rule.fee.amount.value -= commercials.agencyDeductionFee;
            }
        }
    }
    let recruitmentFee = calculate_fee(normalizedSalary, 0, recruitmentFeeSettings, commercials.currency);
    let allFees = [];
    for (let [payee, fees] of Object.entries(commercials.fees)) {
        for (let fee of fees) {
            allFees.push({
                payee,
                ...calculate_fee(normalizedSalary, 'amount' in recruitmentFee ? recruitmentFee.amount?.amount : { min: recruitmentFee.range.min.amount, max: recruitmentFee.range.max.amount }, fee, commercials.currency)
            });
        }
    } /**/
    return { salary: normalizedSalary, currency: commercials.currency, fees: allFees };
}
